import { render, staticRenderFns } from "./Informes.vue?vue&type=template&id=945bdbe2&scoped=true"
import script from "./Informes.vue?vue&type=script&lang=js"
export * from "./Informes.vue?vue&type=script&lang=js"
import style0 from "./Informes.vue?vue&type=style&index=0&id=945bdbe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945bdbe2",
  null
  
)

export default component.exports